import { Type } from "@themes/pollinator/ui/Type";
import { Loader } from "@themes/pollinator/ui/Loader";

export function VideoMeetingLoading() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] gap-4">
      <div>
        <Type variant="h4">Verifying Access...</Type>
        <Loader />
      </div>
    </div>
  );
}
